type Range = { start: number; length: number };

/** Finds literal markers outside existing fields, using document positions. */
export function findNestedVariableMarkers(
  cell: Range,
  fields: Range[],
  getText: (range: Range) => string,
) {
  const end = cell.start + cell.length;
  let cursor = cell.start;
  const markers: { start: number; length: number; variableId: number }[] = [];

  const appendMarkers = (start: number, length: number) => {
    const text = getText({ start, length });
    // Plain ranges exclude field codes/results, so string and document offsets agree.
    for (const match of text.matchAll(/\{DOCVARIABLE (\d+)\}/g)) {
      markers.push({
        start: start + match.index!,
        length: match[0].length,
        variableId: Number(match[1]),
      });
    }
  };

  const containedFields = fields
    .filter((f) => f.start >= cell.start && f.start + f.length <= end)
    .sort((a, b) => a.start - b.start || b.length - a.length);

  for (const field of containedFields) {
    if (field.start < cursor) continue;
    appendMarkers(cursor, field.start - cursor);
    cursor = field.start + field.length;
  }

  appendMarkers(cursor, end - cursor);
  return markers.reverse();
}
